<template>
  <div class="loginWrapper">
    <div class="baseHeaderBox">
      <div class="baseHeaderContainer">
        <div class="baseHeaderImg">
          <img src="../assets/images/frame_logo.png" alt="" />
        </div>
      </div>
    </div>
    <div class="logininBox">
      <div class="logininContainer">
        <div class="logininImg">
          <img src="https://ywaq.obs.cn-north-4.myhuaweicloud.com:443/scana_static/sso-logininIg.png" alt="" />
        </div>
        <div class="logininFormContainer">
          <div class="logininFormContent">
            <div class="logininFormTabs">
              <div @click="handleTabChange('phone')" :class="activetab === 'phone' ? 'tabItem active' : 'tabItem'">
                <span>手机号验证码登录</span>
              </div>
              <div
                @click="handleTabChange('password')"
                :class="activetab === 'password' ? 'tabItem active' : 'tabItem'"
              >
                <span>账号密码登录</span>
              </div>
            </div>
            <div class="logininFormconts">
              <div class="loginininputconts">
                <!-- 手机验证码 -->
                <div class="form-box" v-if="activetab === 'phone'">
                  <el-input class="cus-input" v-model="form.account" placeholder="请输入手机号" />

                  <el-input
                    class="cus-input"
                    v-model="form.secret"
                    placeholder="请输入验证码"
                    @keyup.enter.native="handleLogin"
                  >
                    <template slot="append">
                      <span>
                        <span
                          @click="handleGetCode"
                          :class="form.account ? 'active-phone-code phone-code-color' : 'disabled-phone-code'"
                          v-if="!timer"
                          >获取验证码</span
                        >
                        <span v-else class="disabled-phone-code"
                          >重新获取<span class="phone-code-color">（{{ timer }}）</span></span
                        >
                      </span>
                    </template>
                  </el-input>
                </div>
                <!-- 账号密码 -->
                <div class="form-box" v-if="activetab === 'password'">
                  <el-input class="cus-input" v-model="form.account" placeholder="请输入手机号/邮箱" />

                  <el-input
                    class="cus-input"
                    v-model="form.secret"
                    type="password"
                    placeholder="请输入密码"
                    @keyup.enter.native="handleLogin"
                    show-password
                  />
                </div>
                <div>
                  <el-button
                    :disabled="!form.account || !form.secret"
                    type="primary"
                    @click="handleLogin"
                    style="width: 100%; height: 50px"
                    >登录</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="loginTips">
           <!--  <i class="el-icon-warning-outline"></i>
            提示：若您是新用户，第一次登录时默认注册 -->
          </div>
          <div class="df jcc mt10">
            了解
            <a href="https://www.yunaq.com/agreement?set_area=zh" target="_blank" class="cm curp"
              >《知道创宇服务协议》及《用户隐私政策》</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="baseFooterBox">
      <div class="baseFooterContainer">
        Copyright@北京知道创宇信息技术股份有限公司
        <br />
        京ICP备10040895号-46|京公网安备11010502034763号|《中华人民共和国增值电信业务经营许可证》编号：B1-20210729
        B2-20200545
      </div>
    </div>
  </div>
</template>

<script>
import { loginAccount, getGeeCode, refreshToken } from '@/apis/login'
import { SSO_TOKEN, SSO_USER_INFO } from '@/config'
export default {
  data() {
    return {
      activetab: 'phone',
      form: {
        account: '',
        secret: '',
      },
      timer: 0,
      timeInterval: null,
    }
  },
  watch: {
    activetab() {
      this.form = {
        account: '',
        secret: '',
      }
    },
  },
  methods: {
    handleTabChange(type) {
      this.activetab = type
    },
    handleStartCountTime() {
      this.timer = 60
      this.timeInterval = setInterval(() => {
        if (this.timer <= 0) {
          clearInterval(this.timeInterval)
          return
        }
        this.timer = this.timer - 1
      }, 1000)
    },
    handleGetCode() {
      if (!this.form.account) return
      getGeeCode({
        phone: this.form.account,
      }).then((res) => {
        if (res.code === 200) {
          this.handleStartCountTime()
        }
      })
    },
    async handleLogin() {
      let obj = {}
      if (this.activetab === 'phone') {
        obj.account = this.form.account
        obj.phone_code = this.form.secret
      } else {
        obj = Object.assign(obj, this.form)
      }
      const { redirect_uri, client_id } = this.$route.query
      const res = await loginAccount({
        ...obj,
        client_id,
        redirect_uri,
      })
      if (res.code === 200) {
        window.localStorage.setItem(SSO_USER_INFO, JSON.stringify(res.user_info))
        window.localStorage.setItem(SSO_TOKEN, res.token)
        if (res.redirect_uri && redirect_uri) {
          window.location.replace(res.redirect_uri)
        } else {
          this.$router.push({ name: 'Home' })
        }
      }
    },
  },
  async mounted() {
    const hasLogin = window.localStorage.getItem(SSO_TOKEN)
    if (hasLogin) {
      const { redirect_uri, client_id } = this.$route.query
      const res = await refreshToken({
        client_id,
        redirect_uri,
      })
      if (res.code === 200) {
        if (res.redirect_uri) {
          window.location.replace(res.redirect_uri)
        } else {
          this.$router.push({ name: 'Home' })
        }
      }
    }
  },
}
</script>

<style lang="scss">
.loginWrapper {
  min-height: 100vh;
  background: url('https://ywaq.obs.cn-north-4.myhuaweicloud.com:443/scana_static/sso-baseBg.jpg') no-repeat 50% / cover;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .baseHeaderBox {
    height: 80px;
    width: 100%;
    background: transparent;
    box-sizing: border-box;
    .baseHeaderContainer {
      max-width: 1200px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      .baseHeaderImg {
        //width: 144px;
        img {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .logininBox {
    height: calc(100vh - 180px);
    min-height: 587px;
    .logininContainer {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      .logininImg {
        width: 544px;
        height: 440px;
        img {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }
      .logininFormContainer {
        background: #fff;
        border: 1px solid #e6eaef;
        box-shadow: 0 10px 15px 0 rgba(216, 226, 240, 0.3);
        border-radius: 4px;
        height: 548px;
        width: 448px;
        padding: 80px 40px 48px;
        box-sizing: border-box;
        .logininFormTabs {
          display: flex;
          .tabItem {
            flex: 1 1;
            text-align: center;
            font-size: 18px;
            color: #686c78;
            letter-spacing: 0;
            line-height: 24px;
            font-weight: 400;
            cursor: pointer;
            -webkit-user-select: none;
            -ms-user-select: none;
            user-select: none;
            span {
              &::after {
                content: '';
                display: inline-block;
                width: 100%;
                height: 4px;
                border-radius: 2px;
              }
            }
          }
          .active {
            span {
              color: #1e1f23;
              font-weight: 600;
              &::after {
                background: #0b6fd6;
              }
            }
          }
        }
        .logininFormconts {
          padding: 40px 0 16px;
          .loginininputconts {
            .form-box {
              margin-bottom: 23px;
            }
            .cus-input {
              margin-bottom: 28px;
              .el-input-group__append {
                background: #fff;
              }
              input {
                height: 50px;
              }
            }
            .active-phone-code {
              cursor: pointer;
            }
            .disabled-phone-code {
              cursor: not-allowed;
            }
            .phone-code-color {
              color: #0b6fd6;
            }
          }
        }
      }
      .loginTips {
        font-size: 12px;
        color: #999ea8;
      }
    }
  }
  .baseFooterBox {
    width: 100%;
    height: 100px;
    .baseFooterContainer {
      display: flex;
      justify-content: center;
      font-size: 14px;
      color: #999ea8;
      line-height: 24px;
      text-align: center;
      align-items: center;
      height: 100%;
    }
  }
}
</style>
